function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { Row, Col, InputGroup, Input, Label, Button } from 'reactstrap';
import { _translate, WeverCoreContext } from "../../../../services/core";
import { useWorkFlow } from "../../../contexts/workflow";
import Autocomplete from "../../../form/autocomplete";
import Icon from "../../../common/icon";
import StartFlag from "../../../assets/flag-solid";
import EndFlag from "../../../assets/flag-checkered";
import BusStop from "../../../assets/bus-stop";
import Responses from "./responses";
export default (function (props) {
  var _currentQuestion$publ, _currentQuestion$publ2, _currentQuestion$publ3, _currentQuestion$publ4, _stop$line, _stop$line2, _stop$arrival, _stop$arrival2, _stop$arrival3;
  var stop = props.stop,
    isBetween = props.isBetween,
    handleModeChange = props.handleModeChange,
    handleChange = props.handleChange,
    handleAutocompleteChange = props.handleAutocompleteChange,
    getPointsFilters = props.getPointsFilters,
    index = props.index,
    name = props.name,
    categorizedExpectedResponse = props.categorizedExpectedResponse,
    hasResponse = props.hasResponse,
    deleteTransport = props.deleteTransport;
  var _useWorkFlow = useWorkFlow(),
    collector = _useWorkFlow.collector;
  var _useContext = useContext(WeverCoreContext),
    locale = _useContext.locale;
  var currentQuestion = collector.currentQuestion;
  var excluded_modes = (_currentQuestion$publ = currentQuestion.publicParameters) === null || _currentQuestion$publ === void 0 ? void 0 : _currentQuestion$publ.excluded_modes;
  var excluded_modes_center = (_currentQuestion$publ2 = currentQuestion.publicParameters) === null || _currentQuestion$publ2 === void 0 ? void 0 : _currentQuestion$publ2.excluded_modes_center;
  var min_character_search = (_currentQuestion$publ3 = currentQuestion.publicParameters) === null || _currentQuestion$publ3 === void 0 ? void 0 : _currentQuestion$publ3.min_character_search;
  var points_filters = (_currentQuestion$publ4 = currentQuestion.publicParameters) === null || _currentQuestion$publ4 === void 0 ? void 0 : _currentQuestion$publ4.points_filter_with_lines;
  excluded_modes = excluded_modes ? JSON.parse(excluded_modes) : null;
  excluded_modes_center = excluded_modes_center ? JSON.parse(excluded_modes_center) : null;
  points_filters = points_filters ? JSON.parse(points_filters) : null;
  var lineId = ((_stop$line = stop.line) === null || _stop$line === void 0 ? void 0 : _stop$line.id) || ((_stop$line2 = stop.line) === null || _stop$line2 === void 0 ? void 0 : _stop$line2._id);
  var JourneyFlag = BusStop;
  var classJourneyFlag = 'middle';
  if (index === 0) {
    JourneyFlag = StartFlag;
    classJourneyFlag = 'start';
  } else if (index !== 0 && !isBetween) {
    JourneyFlag = EndFlag;
    classJourneyFlag = 'end';
  }
  var dashedLine = function dashedLine(className) {
    return /*#__PURE__*/React.createElement("div", {
      className: "stop-line d-flex justify-content-center pr-3  ".concat(className)
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner"
    }));
  };
  return /*#__PURE__*/React.createElement(Row, {
    className: "transport-container"
  }, isBetween && /*#__PURE__*/React.createElement(Button, {
    className: "close",
    onClick: function onClick() {
      return deleteTransport(index);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "times-circle"
  })), /*#__PURE__*/React.createElement(Col, {
    className: "col-1 px-0 d-flex align-items-center justify-content-end flag-parent  col"
  }, dashedLine('h-100'), /*#__PURE__*/React.createElement("div", {
    className: "journey flag ".concat(classJourneyFlag)
  }, /*#__PURE__*/React.createElement(JourneyFlag, {
    className: "journey-flag"
  }))), /*#__PURE__*/React.createElement(Col, {
    className: "col-11"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "m-0 p-0 ".concat(isBetween ? 'stop-between  bg-light-2' : '')
  }, isBetween && /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mt-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title-journey fw-bold"
  }, _translate("".concat(index, "ndegres")), " ", _translate('collectorapp_journey_tp'))), !isBetween && /*#__PURE__*/React.createElement(Col, {
    className: "col-12 ".concat(index === 0 ? 'pb-2 mb-1' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "pb-1"
  }, name), index === 0 && dashedLine('titleSlash')), hasResponse && /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mb-2"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Responses, {
    responses: currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.expectedResponses,
    excluded: !isBetween ? excluded_modes : excluded_modes_center,
    mode: stop.mode,
    locale: locale,
    indexRow: index,
    onChange: function onChange() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return handleModeChange.apply(void 0, ['mode'].concat(args));
    }
  }))), isBetween && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mb-3"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 m-0"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "text-center p-0 m-0  col-md-10 stop-autocomplete"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    placeholder: _translate('collectorapp_journey_placeholder_point'),
    name: "name",
    min_character_search: min_character_search,
    resource: "GeometryPoint",
    filters: _objectSpread(_objectSpread({}, getPointsFilters(null, stop.mode)), {}, {
      no_limit: true
    }),
    tag: "name",
    display: "name",
    key: "".concat(currentQuestion.alias, "_").concat(stop.id, "_").concat(stop.mode),
    onChange: function onChange() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return handleChange.apply(void 0, args.concat([index]));
    },
    value: stop.id && stop.alias ? stop : null,
    disabled: (stop === null || stop === void 0 ? void 0 : stop.alias) === 'NA',
    groupClassName: "".concat(!stop.mode ? 'no-event' : '')
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "edit",
    className: "edit-autoomplete color-red-wever"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: (stop === null || stop === void 0 ? void 0 : stop.alias) === 'NA',
    checked: (stop === null || stop === void 0 ? void 0 : stop.alias) === 'NA',
    onChange: function onChange(e) {
      return handleChange(null, {
        value: e.target.checked ? 'NA' : {
          name: null,
          alias: null,
          id: null
        }
      }, index);
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know'))))))), categorizedExpectedResponse && categorizedExpectedResponse.includes(stop.mode) && /*#__PURE__*/React.createElement(Col, {
    className: "col-12 mb-3"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 mx-0"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "10",
    className: "text-center p-0 m-0 "
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/lines/".concat(currentQuestion.id),
    key: "".concat(stop.id, "_").concat(stop.mode, "_").concat(lineId),
    name: "line",
    resource: "GeometryLine",
    min_character_search: min_character_search,
    filters: {
      'points[0]': stop.id,
      mode: stop.mode,
      no_limit: true
    },
    tag: "name",
    display: "name",
    onChange: function onChange() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return handleAutocompleteChange.apply(void 0, ['line'].concat(args, [index]));
    },
    value: stop.line !== 'NA' ? stop.line : null,
    autoload: true,
    cache: false,
    disabled: stop.line === 'NA',
    placeholder: _translate('collectorapp_journey_placeholder_line'),
    groupClassName: "m-0 ".concat(!stop.mode ? 'no-event' : '')
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: stop.line === 'dont_know',
    checked: stop.line === 'NA',
    onChange: function onChange(e) {
      return handleAutocompleteChange('line', null, {
        value: e.target.checked ? 'NA' : null
      }, index);
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know'))))))), /*#__PURE__*/React.createElement(Col, {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "p-0 mx-0 mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "10",
    className: "text-center p-0 m-0 stop-autocomplete"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    alias: currentQuestion.alias,
    urlResource: "/autocomplete/points/".concat(currentQuestion.id),
    placeholder: _translate('collectorapp_journey_placeholder_point_arrival'),
    name: "name",
    resource: "GeometryPoint",
    min_character_search: min_character_search,
    key: "arrival_".concat(lineId, "_").concat(stop === null || stop === void 0 || (_stop$arrival = stop.arrival) === null || _stop$arrival === void 0 ? void 0 : _stop$arrival.id, "_").concat(stop.mode),
    filters: _objectSpread(_objectSpread({}, getPointsFilters([lineId], stop.mode)), {}, {
      no_limit: true
    }),
    tag: "name",
    display: "name",
    onChange: function onChange() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return handleAutocompleteChange.apply(void 0, ['arrival'].concat(args, [index]));
    },
    value: stop.arrival,
    cache: false,
    disabled: stop.arrival === 'NA',
    autoload: true,
    groupClassName: "m-0 ".concat(!stop.mode ? 'no-event' : '')
  }), /*#__PURE__*/React.createElement(Icon, {
    name: "edit",
    className: "edit-autoomplete color-red-wever"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    md: "2",
    className: "p-0 m-0 d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputGroup, {
    className: "justify-content-center label-dont-know"
  }, /*#__PURE__*/React.createElement(Label, {
    className: "m-0"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "checkbox",
    name: "dont-know",
    value: stop.arrival === 'NA' || ((_stop$arrival2 = stop.arrival) === null || _stop$arrival2 === void 0 ? void 0 : _stop$arrival2.alias) === 'NA',
    checked: stop.arrival === 'NA' || ((_stop$arrival3 = stop.arrival) === null || _stop$arrival3 === void 0 ? void 0 : _stop$arrival3.alias) === 'NA',
    onChange: function onChange(e) {
      return handleAutocompleteChange('arrival', null, {
        value: e.target.checked ? 'NA' : null
      }, index);
    }
  }), /*#__PURE__*/React.createElement("span", null, _translate('collectorapp_dont_know')))))))))));
});